// @flow

export { InputParaguayanDocument } from './input-paraguayan-document';
export { InputParaguayanPhoneNumber } from './input-paraguayan-phone-number';
export { InputParaguayanZipcode } from './input-paraguayan-zipcode';
